export default __webpack_public_path__ + "static/media/game-pagetype-alreadyplayed_game.fefb91a6.svg";